document.addEventListener('DOMContentLoaded', function() {
    // Initialize calculators on the page
    initializeCalculators();

    function initializeCalculators() {
        // Check for standalone calculator
        const standaloneCalculator = document.querySelector('.section-pavers-calculator');
        
        // Check for side panel calculator
        const sidePanelCalculator = document.querySelector('#panel-calculator');
        
        if (standaloneCalculator) {
            console.log("Initializing standalone pavers calculator");
            setupCalculator({
                containerSelector: '.section-pavers-calculator',
                isDropdownSelector: true
            });
        }
        
        if (sidePanelCalculator) {
            console.log("Initializing side panel pavers calculator");
            setupCalculator({
                containerSelector: '#panel-calculator',
                isDropdownSelector: true
            });
        }
        
        if (!standaloneCalculator && !sidePanelCalculator) {
            console.log("No pavers calculators found on this page");
        }
    }

    function setupCalculator(config) {
        const container = document.querySelector(config.containerSelector);
        if (!container) return;
        
        // Get DOM elements within this calculator
        const lengthInput = container.querySelector('#length');
        const widthInput = container.querySelector('#width');
        const manualAreaInput = container.querySelector('#manual-area');
        const dimensionsSection = container.querySelector('#dimensions-section');
        const manualAreaSection = container.querySelector('#manual-area-section');
        
        // Check for both regular and panel-specific radio buttons
        let calculationTypeRadios = container.querySelectorAll('input[name="calculation-type"]');
        if (calculationTypeRadios.length === 0) {
            calculationTypeRadios = container.querySelectorAll('input[name="paver-panel-calculation-type"]');
        }
        
        const projectAreaDisplay = container.querySelector('#project-area');
        const totalPaversDisplay = container.querySelector('#total-pavers');
        const paverSizeSelect = container.querySelector('#paver-size-select');
        
        // Check if required elements exist
        if (!projectAreaDisplay || !totalPaversDisplay || !paverSizeSelect) {
            console.log("Required calculator elements not found in", config.containerSelector);
            return;
        }
        
        // Track which calculation mode is active
        let isUsingDimensions = true;
        
        // Calculate function for this calculator instance
        function calculatePavers() {
            let area = 0;
            
            // Calculate area based on active calculation mode
            if (isUsingDimensions) {
                // Get input values from dimensions
                const length = parseFloat(lengthInput.value) || 0;
                const width = parseFloat(widthInput.value) || 0;
                
                // Calculate area from dimensions
                area = length * width;
                
                // Update displayed area only in dimensions mode
                if (projectAreaDisplay) {
                    projectAreaDisplay.textContent = area.toFixed(2);
                }
            } else {
                // Get area directly from manual input
                area = parseFloat(manualAreaInput.value) || 0;
                
                // In manual mode, we don't update the project area display
                // because it's hidden and redundant
            }
            
            // Get the selected variant's coverage rate
            const selectedOption = paverSizeSelect.options[paverSizeSelect.selectedIndex];
            
            // Get coverage rate (units per m²), default to 1 if not available
            let coverageRate = 1;
            if (selectedOption.dataset.coverage) {
                coverageRate = parseFloat(selectedOption.dataset.coverage) || 1;
            }
            
            // Calculate number of pavers needed using the coverage rate
            const numberOfPavers = Math.ceil(area * coverageRate);
            
            totalPaversDisplay.textContent = numberOfPavers;
        }
        
        // Get the project area section that contains #project-area
        let projectAreaSection = null;
        const projectAreaSpan = container.querySelector('#project-area');
        if (projectAreaSpan) {
            // Find the parent calculator-section
            projectAreaSection = projectAreaSpan.closest('.calculator-section');
        }
        
        // Function to toggle between calculation modes
        function toggleCalculationMode(mode) {
            console.log("Toggling calculation mode to:", mode);
            isUsingDimensions = (mode === 'dimensions');
            
            if (isUsingDimensions) {
                // Show dimensions, hide manual area
                if (dimensionsSection) {
                    dimensionsSection.style.display = 'block';
                    console.log("Showing dimensions section");
                }
                if (manualAreaSection) {
                    manualAreaSection.style.display = 'none';
                    console.log("Hiding manual area section");
                }
                
                // Show project area since it's calculated from dimensions
                if (projectAreaSection) {
                    projectAreaSection.style.display = 'block';
                }
                
                // Enable dimension inputs
                if (lengthInput) {
                    lengthInput.disabled = false;
                    lengthInput.parentElement.style.opacity = '1';
                }
                if (widthInput) {
                    widthInput.disabled = false;
                    widthInput.parentElement.style.opacity = '1';
                }
                
                // Disable manual area input
                if (manualAreaInput) {
                    manualAreaInput.disabled = true;
                }
            } else {
                // Hide dimensions, show manual area
                if (dimensionsSection) {
                    dimensionsSection.style.display = 'none';
                    console.log("Hiding dimensions section");
                }
                if (manualAreaSection) {
                    manualAreaSection.style.display = 'block';
                    console.log("Showing manual area section");
                }
                
                // Hide project area since it's redundant when entering area manually
                if (projectAreaSection) {
                    projectAreaSection.style.display = 'none';
                }
                
                // Disable dimension inputs
                if (lengthInput) {
                    lengthInput.disabled = true;
                    lengthInput.parentElement.style.opacity = '0.5';
                }
                if (widthInput) {
                    widthInput.disabled = true;
                    widthInput.parentElement.style.opacity = '0.5';
                }
                
                // Enable manual area input
                if (manualAreaInput) {
                    manualAreaInput.disabled = false;
                }
            }
            
            calculatePavers();
        }
        
        // Add event listeners
        if (lengthInput) lengthInput.addEventListener('input', calculatePavers);
        if (widthInput) widthInput.addEventListener('input', calculatePavers);
        if (manualAreaInput) manualAreaInput.addEventListener('input', calculatePavers);
        if (paverSizeSelect) paverSizeSelect.addEventListener('change', calculatePavers);
        
        // Add listeners to radio buttons and initialize the mode
        if (calculationTypeRadios && calculationTypeRadios.length > 0) {
            calculationTypeRadios.forEach(radio => {
                radio.addEventListener('change', function() {
                    console.log("Radio changed to:", this.value);
                    toggleCalculationMode(this.value);
                });
            });
            
            // Initialize the mode based on the checked radio button
            const checkedRadio = container.querySelector('input[name="calculation-type"]:checked');
            if (checkedRadio) {
                console.log("Initial mode:", checkedRadio.value);
                toggleCalculationMode(checkedRadio.value);
            }
        } else {
            console.log("Calculation type radios not found");
        }
        
        // Initialize calculator
        calculatePavers();
        console.log("Calculator initialized for", config.containerSelector);
    }
});